import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import type { Certificate } from "@/lib/mock";
import { CertificateTypeIcon } from "./CertificateTypeIcon";
import { StatusBadge } from "./StatusBadge";
import { ExpiryMeter } from "./ExpiryMeter";
import { useT } from "@/i18n";
import { daysBetween, formatDate } from "@/lib/format";

export function CertificateCard({ certificate }: { certificate: Certificate }) {
  const { t, locale } = useT();
  const remaining = daysBetween(certificate.expiresAt);
  const validityDays = certificate.validityYears * 365;

  return (
    <Link
      to={`/certificados/${certificate.id}`}
      className="card group flex items-center gap-5 p-5 transition hover:-translate-y-0.5 hover:shadow-card"
    >
      <CertificateTypeIcon type={certificate.type} size="lg" />

      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <StatusBadge status={certificate.status} />
          <span className="truncate text-xs text-slate-500">
            {certificate.issuer}
          </span>
        </div>
        <p className="mt-2 truncate text-base font-semibold text-slate-900">
          {t(`type.${certificate.type}` as const)}
        </p>
        <p className="truncate text-sm text-slate-600">{certificate.holder}</p>
        <p className="mt-2 text-xs text-slate-500">
          {t("cert.expires_on")}: {formatDate(certificate.expiresAt, locale)}
        </p>
      </div>

      <div className="hidden sm:block">
        <ExpiryMeter daysRemaining={remaining} validityDays={validityDays} />
      </div>

      <ChevronRight className="h-5 w-5 flex-none text-slate-400 transition group-hover:text-slate-600" />
    </Link>
  );
}
